import { typeOf } from './typeOf'

export const BadData = typeOf('bad-data')
export const BadRequest = typeOf('bad-request')
export const BadStatus = typeOf('bad-status')
export const Err = typeOf('err')
export const Ok = typeOf('ok')
